// @flow

// TODO: after updating react-router-config to version 6, try to remove this wrapper
// and implement the transition along the routes with a duplicate slash without it
export const removeRoutePathExtraSlash = (path: string) => path.replace(/\/{2,}/g, '/');
